export default __webpack_public_path__ + "static/media/img-16-proven-ways.820c1b28.png";